import { IListingCompilation } from '../../types/promosPage';
import { IApplicationState } from '../../types/redux';

export const selectListingCompilations = (state: IApplicationState): IListingCompilation[] => {
  return state.promosPage.listingCompilations;
};
